// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1jcW8","info":"PatientInfo_info__3vguZ"};